/* eslint-disable no-console */
import { MultilineText } from "@app/components/core/MultilineText/MultilineText"
import SucceedCheckmark from "@app/components/core/SucceedCheckmark"
import Button from "@app/components/move2Library/Button/Button"
import { useGetStrings } from "@app/store/service/cmsService"
import { appStore } from "@app/store/store"
import { Modal, useModal } from "@tecreation/funnel-components"
import { useEffect } from "react"

export default function SavedPaymentModal({ saved }) {
	const modal = useModal()
	const {
		data: {
			buttonClose,
			myParadiseSavedPaymentTitleSuccess,
			myParadiseSavedPaymentTitleFail,
			myParadiseSavedPaymentBodySuccess,
			myParadiseSavedPaymentBodyFail,
		},
	} = useGetStrings(undefined, { defaultData: {} })

	useEffect(() => {
		appStore.set("core.relationPaymentToken", undefined)
	}, [])

	console.log(saved)

	return (
		<Modal>
			<Modal.Closer />
			<Modal.Header>{saved == "true" ? myParadiseSavedPaymentTitleSuccess : myParadiseSavedPaymentTitleFail}</Modal.Header>

			<Modal.Body className="body">
				<div className="flex flex-center mb-4">{saved == "true" ? <SucceedCheckmark size={70} /> : undefined}</div>
				<MultilineText>{saved == "true" ? myParadiseSavedPaymentBodySuccess : myParadiseSavedPaymentBodyFail}</MultilineText>
			</Modal.Body>
			<Modal.Footer>
				<div className="flex flex-center">
					<Button style="primary" onClick={modal.hideModal}>
						{buttonClose}
					</Button>
				</div>
			</Modal.Footer>
		</Modal>
	)
}
